import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FaceMap, InputFilter, ScreenForList } from '../model/store.model';
import { SelectFaceFromMapOutput } from '../map-item/map-item.component';
import { ScreenService } from '../services/screen.service';
import { FilterResult } from '../../../helpers/crud/repository.service';
import { map } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { ConfirmationDialogComponent } from '../../../helpers/dialog/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-see-selected-screen',
    templateUrl: './see-selected-screen.component.html',
    styleUrls: ['./see-selected-screen.component.scss'],
})
export class SeeSelectedScreenComponent {
    public screenList: ScreenForList[] = [];
    public hasDateSelected: boolean = false;
    public recapFilterParams: InputFilter;
    public userLat?: number;
    public userLon?: number;
    public selectedFaceIds: number[];
    public startDate: any;
    public endDate: any;
    public isListLoading: boolean = true;
    public faceIdsRemoved: number[] = [];

    // For InfiniteScroll
    public total$;
    public alreadyCalled: boolean = false;

    //MARK: Constructor
    constructor(
        private dialogRef: MatDialogRef<SeeSelectedScreenComponent>,
        private screen$: ScreenService,
        private waiting$: WaitingService,
        private dialog: MatDialog
    ) {
        this.total$ = this.screen$.pipe(map((d) => d.total));
    }

    /**
     * Retire la face de la liste
     * @param event infos de l'écran désélectionné
     */
    unselectScreen(event: SelectFaceFromMapOutput) {
        this.faceIdsRemoved.push(event.face.id);
        let index: number = 0;

        this.screenList.forEach((sl) => {
            sl.fAs.forEach((face) => {
                if (face.id === event.face.id) {
                    //Supprime seulement la face si Plusieurs faces
                    if (sl.fAs.length > 1) {
                        sl.fAs = sl.fAs.filter((f) => f.id !== event.face.id);
                    } else {
                        this.screenList.splice(index, 1);
                    }
                }
            });
            index = index + 1;
        });

        //Reload si possible
        if (this.screenList.length <= 8 && this.screenList.length > 0) {
            this.onScroll();
        }

        //Si plus d'écrans, ferme lle récap
        if (this.screenList.length <= 0 && !this.canScroll()) {
            this.dialogRef.close();
        }
    }

    /**
     * Charge et ajoute les écrans dans la liste
     */
    loadRecap() {
        //Loadings
        this.isListLoading = true;
        const waitingId: string = this.waiting$.start();

        this.screen$
            .getScreenList(
                this.userLat,
                this.userLon,
                this.selectedFaceIds,
                this.recapFilterParams,
                {
                    startDate: this.startDate,
                    endDate: this.endDate,
                }
            )
            .subscribe({
                next: (getScreenListResult: FilterResult<ScreenForList>) => {
                    this.waiting$.end(waitingId);
                    this.alreadyCalled = false;

                    getScreenListResult.items.forEach((sl: ScreenForList) => {
                        sl.fAs.forEach((face: FaceMap) => {
                            face.selected = true;
                        });
                    });
                    this.total$ = getScreenListResult.total;
                    //Append screens
                    this.screenList.push(...getScreenListResult.items);
                    this.isListLoading = false;
                },
                error: (err: HttpErrorResponse) => {
                    this.waiting$.end(waitingId);
                    this.alreadyCalled = false;
                    console.error(err);
                    this.isListLoading = false;
                },
            });
    }

    /**
     * Appellée au scroll infini
     */
    onScroll() {
        if (this.canScroll()) {
            this.alreadyCalled = true;
            this.recapFilterParams.page++;

            this.loadRecap();
        }
    }

    /**
     *
     * @returns `true` si des écrans restent à afficher dans le scroll
     */
    private canScroll(): boolean {
        let total: number = 0;
        total = this.total$;
        return (
            !this.alreadyCalled &&
            total / this.recapFilterParams.pageSize >
                this.recapFilterParams.page + 1
        );
    }

    /**
     * Vide le panier et ferme le récap
     */
    public emptyCart() {
        this.dialog
            .open(ConfirmationDialogComponent, {
                data: {
                    title: 'Suppression du panier',
                    message: `Etes-vous sûr de vouloir retirer tous vos écran(s) du panier ?`,
                    okText: 'Valider',
                    cancelText: 'Annuler',
                },
            })
            .afterClosed()
            .subscribe((res: { response: boolean }) => {
                if (res.response) {
                    this.screenList = [];
                    this.dialogRef.close();
                }
            });
    }
}
